// @flow
import React, { PureComponent, Fragment } from "react";
import { isNumber, toNumber, noop } from "lodash";

import formatCurrency from "@tvg/formatter/currency";
import type { NullaryFn } from "@tvg/types/Functional";

import { QDText, QDamount, QDlabel, QDIcon } from "./styled-components";
import buildColor from "../../_static/ColorPalette";
import { quickDeposit } from "../../_static/Icons/icons";
import ButtonLink from "../../_atom/Buttons/buttonLink";

export type QuickDepositType = {
  /**
   * Balance amount
   */
  balance: number,
  /**
   * Show/Hide user's balance
   */
  isBalanceShown: boolean,
  /**
   * Navigation when clicking the quick deposit button link
   */
  url: string,
  /**
   * On click callback (ie. GTM event handling)
   */
  onClick?: NullaryFn<mixed>
};

type Props = {
  /**
   * User's balance
   */
  balance: number,
  /**
   * User's balance
   */
  balanceThreshold: number,
  /**
   * Url for the navigation to the DMA
   */
  url: string,
  /**
   * Hide/Show User's balance.
   */
  isBalanceShown: boolean,
  /**
   * Abbreviate 'Quick Deposit' label
   */
  isAbbreviated: boolean,
  /**
   * Is Quick Deposit on video
   */
  isOnVideo?: boolean,
  /**
   * On click callback (ie. GTM event handling)
   */
  onClick: NullaryFn<mixed>,
  /**
   * Used to show a micro version of the quick deposit button, as shown on the video player
   */
  isMicro: boolean
};

export default class QuickDepositButton extends PureComponent<Props> {
  static defaultProps = {
    balance: 0,
    balanceThreshold: 20,
    url: "/",
    isBalanceShown: false,
    isAbbreviated: false,
    isOnVideo: false,
    isMicro: false,
    onClick: noop
  };

  renderText = () => {
    const balanceBellowThreshold =
      isNumber(this.props.balance) &&
      toNumber(this.props.balance) < this.props.balanceThreshold;

    return (
      <QDText>
        {this.props.isBalanceShown ? (
          <Fragment>
            {balanceBellowThreshold && !this.props.isMicro && (
              <QDlabel>
                {this.props.isAbbreviated ? "Q. Deposit" : "Quick Deposit"}
              </QDlabel>
            )}
            <QDamount isMicro={this.props.isMicro}>
              {`${formatCurrency(toNumber(this.props.balance))}`}
            </QDamount>
          </Fragment>
        ) : (
          <QDlabel isAbbreviated={this.props.isAbbreviated}>
            {this.props.isAbbreviated ? "Q. Deposit" : "Quick Deposit"}
          </QDlabel>
        )}
      </QDText>
    );
  };

  render() {
    return (
      <ButtonLink
        type={this.props.isOnVideo ? "shadow" : "secondary_alt"}
        size={this.props.isMicro ? "micro" : "default"}
        url={this.props.url}
        qaLabel="quickDepositButton"
        onClick={this.props.onClick}
      >
        {!this.props.isMicro && (
          <QDIcon
            icon={quickDeposit}
            size={16}
            color={buildColor("white", "100")}
          />
        )}
        {this.renderText()}
      </ButtonLink>
    );
  }
}
